// Selectors for auth state
export const selectAuth = state => state.auth;
export const selectUser = state => state.auth.user;
export const selectIsAuthenticated = state => state.auth.isAuthenticated;
export const selectAuthLoading = state => state.auth.loading;
export const selectAuthError = state => state.auth.error;
export const selectAuthToken = state => state.auth.token;
export const selectAuthRefreshToken = state => state.auth.refreshToken;
export const selectRememberMe = state => state.auth.rememberMe;
export const selectUserPreferences = state => state.auth.userPreferences;
